var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navbar-menu-item',_vm._g({attrs:{"icon":"search","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openSearch()}}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }